import React, { forwardRef } from 'react';
import styles from './ReportPaper.module.css';
import Header from '../header/Header';
import PersonInfos from '../person-infos/PersonInfos';
import Signature from '../signature/Signature';
import Footer from '../footer/Footer';
import { companyHeaderProps, professionalInfos } from './reportCompany';

/**
 * Folha A4 dos relatórios dos módulos de atendimento entregues ao paciente:
 * cabeçalho da clínica, identificação do paciente e do profissional, título e
 * subtítulo, o conteúdo do módulo (`children`), assinatura e rodapé. Mesma
 * aparência do PDF do plano alimentar. Renderizada fora da tela e convertida
 * pelo CreatePDF (html2pdf).
 *
 * `professional`: recurso da clínica (Label, Regulator), ou null.
 * `date`: data mostrada sob a assinatura (DD/MM/YYYY).
 */
const ReportPaper = forwardRef(({ companyData, professional, patientName, title, subtitle, date, children }, ref) => {
  const company = companyData || {};
  const professionalLines = professionalInfos(professional);

  return (
    <div ref={ref} className={styles.paper}>
      {company.Name && <Header {...companyHeaderProps(company)} />}

      <div className={styles.people}>
        <PersonInfos data={[{ key: 'Paciente:', value: patientName || '' }]} />
        {professionalLines.length > 0 && <PersonInfos data={professionalLines} />}
      </div>

      <div className={styles.titleBlock}>
        <h2 className={styles.title}>{title}</h2>
        {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
      </div>

      {children}

      {professional && (
        <div className={styles.signature}>
          <Signature date={date || ''} name={professional.Label || ''} sign="" />
        </div>
      )}
      <Footer />
    </div>
  );
});

ReportPaper.displayName = 'ReportPaper';

export default ReportPaper;
